export default "__VITE_ASSET__Cgy7GsTT__"